import * as i18n from 'react-i18next';
import astro from './astro';
import { ObjectType, getSign, AspectsPatterns, houseAspects, isSynastry, getDirections, directionShift, getGMT, } from "@chronos/astro-lib";
import { localTime, getLocalTime } from "@chronos/api";
import { Dispositors } from './Dispositors';
export const isCompatibility = (mode) => /^compatibility\d*$/.test(mode);
export const isRelocation = (mode) => /^relocation\d+$/.test(mode);
export const isEastern = (current, target) => {
    if (Math.abs(current - target) > 180) {
        if (target < current) {
            target += 360;
        }
        else {
            current += 360;
        }
    }
    return current - target < 180 && current - target > 0;
};
export const intersectionNumberArray = (array1, array2) => array1.filter((elm1) => array2.includes(elm1));
export const intersectionFixedStarsArray = (array1, array2) => {
    return array1.filter((star1) => array2.find((star2) => star1.en === star2.en && star1.lon === star2.lon && star1.drawLon === star2.drawLon));
};
export const calcHorarSigns = (houses) => {
    const signs = [];
    let sign0 = 0;
    for (let h = 0; h < 12; h++) {
        const lon = houses[h];
        let nlon = houses[(h + 1) % 12];
        if (nlon < lon) {
            nlon += 360;
        }
        const dist = nlon - lon;
        for (let s = Math.ceil(lon / 30) * 30; s >= lon && s < nlon; s += 30) {
            if (s % 360 === 0) {
                sign0 = signs.length;
            }
            signs.push(30 * (h + (s - lon) / dist));
        }
    }
    return [
        ...signs.slice(sign0),
        ...signs.slice(0, sign0)
    ];
};
export function highlightAspect(map, aspect, hasExt = false, hasOuter = false, comatibilityReversed = false) {
    if (!aspect) {
        return [];
    }
    const type = (obj, isExt = false, isOuter = false) => ({
        id: obj >= ObjectType.House1 ? obj - ObjectType.House1 : obj,
        type: `${obj >= ObjectType.House1 ? 'house' : 'object'}${isExt && !isOuter ? '_ext' : isOuter ? '_outer' : ''}`
    });
    let result = [];
    if (!('obj3' in aspect)) {
        result = [
            {
                id: aspect.id,
                type: 'aspect',
                map
            },
            {
                ...type(aspect.obj1, hasOuter ? hasExt : false),
                map
            },
            {
                ...type(aspect.obj2, hasExt, hasOuter),
                map
            },
            {
                type: 'sign',
                id: getSign(aspect.lon1),
                map
            },
            {
                type: 'sign',
                id: getSign(aspect.lon2),
                map
            }
        ];
    }
    else {
        const ErisId = 15;
        result = aspect.obj3 === ErisId
            ? []
            : [
                {
                    id: aspect.id,
                    type: 'aspect',
                    map
                },
                ((aspect.obj1 >= 0)
                    ? {
                        ...type(aspect.obj1),
                        map
                    }
                    : undefined),
                (aspect.obj2 >= 0
                    ? {
                        ...type(aspect.obj2, true),
                        map
                    }
                    : undefined),
                {
                    ...type(aspect.obj3, false, true),
                    map
                },
                (aspect.obj1 >= 0
                    ? {
                        type: 'sign',
                        id: getSign(aspect.lon1),
                        map
                    }
                    : undefined),
                (aspect.obj2 >= 0
                    ? {
                        type: 'sign',
                        id: getSign(aspect.lon2),
                        map
                    }
                    : undefined),
                {
                    type: 'sign',
                    id: getSign(aspect.lon3),
                    map
                }
            ].filter(h => h);
    }
    return result;
}
export function showMapInfoPopup(target, lines, evt) {
    const mapsContainer = document.getElementById('chronos-ui-maps');
    const infoPopup = document.querySelector('#map-info-popup');
    infoPopup.style.display = 'block';
    const fragment = document.createDocumentFragment();
    for (let i = 0; i < lines.length; i++) {
        const line = document.createElement('div');
        line.innerHTML = lines[i];
        fragment.append(line);
    }
    infoPopup.innerHTML = '';
    infoPopup.appendChild(fragment);
    const { x: containerX, y: containerY, width: containerWidth } = mapsContainer.getBoundingClientRect();
    const { width: popupWidth, height: popupHeight } = infoPopup.getBoundingClientRect();
    const mouseX = evt.clientX - containerX;
    const mouseY = evt.clientY - containerY;
    const containerThirdPart = containerWidth / 3;
    const mouseInLeftPart = evt.clientX < (containerX + containerThirdPart);
    const mouseInMiddlePart = (evt.clientX >= (containerX + containerThirdPart)) && (evt.clientX <= (containerX + containerThirdPart * 2));
    const mouseInRightPart = evt.clientX > (containerX + containerThirdPart * 2);
    if (mouseInLeftPart) {
        infoPopup.style.left = `${mouseX + 8}px`;
        infoPopup.style.top = `${mouseY - popupHeight - 8}px`;
    }
    else if (mouseInMiddlePart) {
        infoPopup.style.left = `${mouseX - popupWidth / 2}px`;
        infoPopup.style.top = `${mouseY - popupHeight - 8}px`;
    }
    else if (mouseInRightPart) {
        infoPopup.style.left = `${mouseX - popupWidth - 8}px`;
        infoPopup.style.top = `${mouseY - popupHeight - 8}px`;
    }
    infoPopup.style.zIndex = '2';
}
export function hideMapInfoPopup() {
    const info = document.querySelector('#map-info-popup');
    if (!info) {
        return;
    }
    info.style.display = 'none';
}
export const defaultComputedRadius = {
    external: 1,
    internal: 0.7,
    zodiacsInternal: 0.91,
    zodiacsExternal: 1,
    internalExt: 0.55,
    zodiacsInternalExt: 0.77,
    zodiacsExternalExt: 0.86
};
export const defaultPersonalization = {
    circle: {
        scale: {
            min: 0.5,
            max: 3,
            step: 0.05
        },
        gap: 250,
        radius: {
            circle: 360,
            houses: 1.16,
            cusps: 1.1,
            external: 1,
            zodiacsExternal: 1,
            zodiacsInternal: 0.91,
            internal: 0.7,
            internalHorar: 0.35,
            internalSoul: 0.1,
            zodiacsExternalExt: 0.86,
            zodiacsInternalExt: 0.77,
            internalExt: 0.55,
            modifier: {
                objects: 1,
                zodiacs: 1,
                objectsExt: 1
            }
        },
        zodiacs: {
            gap: 0.5,
            iconSize: 0.05,
            style: 1
        },
        houses: {
            width: 1,
            length: 1
        },
        objects: {
            iconSize: 0.065,
            pointSize: 0.008,
            strongSize: 0.006,
            style: 1,
            location: 0
        },
        aspects: {
            icon: 0.05,
            width: 1
        },
        colorThemes: {
            maps: {
                active: 2
            },
            zodiacs: {
                active: 0
            },
            houses: {
                active: 0
            },
            objects: {
                active: 0
            },
            aspects: {
                active: 0
            }
        }
    }
};
export function getOrbit(chains, planet) {
    var _a;
    return ((_a = chains.find(chain => !!chain.objects[planet])) === null || _a === void 0 ? void 0 : _a.objects[planet].orbit) || 0;
}
export const defaultTranslator = {
    t: (v) => v,
    U: (v) => v,
    l: (v) => v
};
export function useTranslation() {
    const { t } = i18n.useTranslation();
    const result = {
        t,
        U: (v, vars) => {
            const x = t(v, vars);
            return x ? x[0].toUpperCase() + x.substring(1) : '';
        },
        l: (v, vars) => {
            const x = t(v, vars);
            return x ? x[0].toLowerCase() + x.substring(1) : '';
        }
    };
    if (!window.hasOwnProperty('translator'))
        window.translator = result;
    return result;
}
async function calcSoul(dt, gmt, lat, lon) {
    const data = await astro.natal(getLocalTime(dt, gmt, lat, lon), lat, lon);
    const disp = Dispositors(data.objects);
    return {
        ...data,
        ...disp
    };
}
export function calcNatalAspectsWithFloatingOrbiseCorrector(aspects, natal, floatingOrbise) {
    if (!floatingOrbise)
        return aspects;
    let newAspects = astro.natalAspects(natal.objects, undefined, natal.houses, undefined, { floatingOrbise });
    const newConfigurations = new AspectsPatterns(newAspects.filter(item => item.obj1 < 10 && item.obj2 < 10)).findPatterns();
    const isSameAspects = (aspect1, aspect2) => (aspect1.obj1 === aspect2.obj1 && aspect1.obj2 === aspect2.obj2) || (aspect1.obj1 === aspect2.obj2 && aspect1.obj2 === aspect2.obj1);
    const aspectInConfigurations = ((aspect, configurations) => configurations.find((configuration) => configuration.aspects.find((confAspect) => isSameAspects(confAspect, aspect))));
    const aspectInArrayOfAspects = ((aspect, aspects) => aspects.find((confAspect) => isSameAspects(confAspect, aspect)));
    newAspects = newAspects.map(a => {
        let aspect = a;
        if (aspectInArrayOfAspects(a, aspects) && !aspectInConfigurations(a, newConfigurations)) {
            aspect = aspects.find((aspect) => isSameAspects(a, aspect));
        }
        return aspect;
    });
    aspects = newAspects.filter(aspect => aspectInConfigurations(aspect, newConfigurations) || aspectInArrayOfAspects(aspect, aspects));
    aspects = aspects.map((item, i) => {
        item.id = i;
        return item;
    });
    return aspects;
}
export async function calculation(mode, form, activeAstroProfile, showHorarAspects, mapIndicator) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    const isNatal = ['natal', 'syn_natal', 'relocation_natal'].includes(mode);
    const astroProfile = activeAstroProfile;
    const floatingOrbise = (_a = (astroProfile && astroProfile.closureConfig)) !== null && _a !== void 0 ? _a : 0;
    if (astroProfile) {
        astro.settings = astroProfile;
        const { maps } = astro.settings;
        astro.settings = {
            ...JSON.parse(JSON.stringify(astroProfile)),
            housesSystem: form.housesSystem || { common: 0, northern: 3, horar: 2 }
        };
        if (maps) {
            Object.keys(maps).forEach(k => {
                astro.settings.maps[k].orbiseCorrector = maps[k].orbiseCorrector;
            });
        }
    }
    form.natal.gmt = (_b = form.natal.gmt) !== null && _b !== void 0 ? _b : getGMT(form.natal.dt, form.natal.place.lat, form.natal.place.lon);
    const ErisObjectNatal = await astro.object(localTime(form.natal), 136199 + 10000);
    const natal = ['soul'].includes(mode)
        ? {
            houses: [],
            objects: []
        }
        : await astro.natal(localTime(form.natal), form.natal.place.lat, form.natal.place.lon, Boolean(form.cosmogram));
    if (isNatal) {
        let aspects = astro.natalAspects(natal.objects, undefined, natal.houses, undefined, { floatingOrbise: 0 });
        aspects = calcNatalAspectsWithFloatingOrbiseCorrector(aspects, natal, floatingOrbise);
        if (mode === 'relocation_natal') {
            aspects.push(...houseAspects(natal.objects, natal.houses, aspects.length, (astroProfile === null || astroProfile === void 0 ? void 0 : astroProfile.id) === 1 ? 5 : 4).map((a) => {
                const z = a.obj1;
                a.obj1 = a.obj2;
                a.obj2 = z;
                return a;
            }));
        }
        return {
            ...natal,
            objects: [...natal.objects, ErisObjectNatal],
            aspects,
            objectsExt: [],
            housesExt: [],
            objectsOuter: [],
            housesOuter: []
        };
    }
    if (mode === 'horar') {
        if (!form.horar)
            throw new Error('Empty horar data');
        const horar = await astro.horar(localTime(form.horar), form.horar.place.lat, form.horar.place.lon);
        const isRounded = false;
        const aspects = showHorarAspects ? astro.natalAspects(horar.objects, undefined, undefined, isRounded) : [];
        const ErisObjectHorar = await astro.object(localTime(form.horar), 136199 + 10000);
        return {
            ...horar,
            objects: [...horar.objects, ErisObjectHorar],
            aspects: aspects,
            objectsExt: [],
            housesExt: [],
            objectsOuter: [],
            housesOuter: []
        };
    }
    if (mode === 'soul') {
        const soul = await calcSoul(form.natal.dt, form.natal.gmt, form.natal.place.lat, form.natal.place.lon);
        return {
            ...soul,
            aspects: [],
            soulObjects: soul.objectsExt,
            housesExt: [],
            objectsOuter: [],
            housesOuter: []
        };
    }
    if (isSynastry(mode)) {
        const partners = ((_c = form.partners) === null || _c === void 0 ? void 0 : _c.length)
            ? form.partners
            : form.synastry
                ? [form.synastry]
                : null;
        if (!partners) {
            throw new Error('Empty synastry data');
        }
        ;
        const partnerIndex = (Number(mode.slice(-1)) - 1) || 0;
        const partner = partners[partnerIndex];
        const partnerExt = (_d = mapIndicator === null || mapIndicator === void 0 ? void 0 : mapIndicator.partnerExt[mode]) !== null && _d !== void 0 ? _d : true;
        const partnerNatal = (_e = mapIndicator === null || mapIndicator === void 0 ? void 0 : mapIndicator.partnerNatal[mode]) !== null && _e !== void 0 ? _e : true;
        const { compatibilityTransits, compatibilityReversed } = mapIndicator;
        if (!partner) {
            throw new Error('Empty synastry data');
        }
        ;
        const ErisObjectPartner = await astro.object(localTime(partner), 136199 + 10000);
        if (isCompatibility(mode)) {
            const ext = await astro.natal(localTime(partner), partner.place.lat, partner.place.lon, false);
            let synastryAspects = [];
            let ErisObjectTransits = null;
            const compatibilityTransitMode = compatibilityTransits[mode].transitMode;
            let compatibilityTransit = null;
            let objectsOuter = [];
            let housesOuter = [];
            let transitPartnerAspects = [];
            let transitNatalAspects = [];
            if (!compatibilityReversed) {
                synastryAspects = astro.synastryAspects(natal.objects, ext.objects);
            }
            else {
                synastryAspects = astro.synastryAspects(ext.objects, natal.objects);
            }
            if (form.syn_prognostics) {
                let { dt: progDt, gmt, place: { lat, lon } } = form.syn_prognostics;
                progDt = getLocalTime(progDt, gmt, lat, lon);
                compatibilityTransit = await astro.natal(progDt, lat, lon, false);
                ErisObjectTransits = await astro.object(progDt, 136199 + 10000);
                if (compatibilityTransits[mode].showTransit) {
                    objectsOuter = [...((compatibilityTransit === null || compatibilityTransit === void 0 ? void 0 : compatibilityTransit.objects) || []), ErisObjectTransits];
                    housesOuter = [...((compatibilityTransit === null || compatibilityTransit === void 0 ? void 0 : compatibilityTransit.houses) || [])];
                    ({
                        transitPartnerAspects,
                        transitNatalAspects
                    } = astro.synastryTransitAspects(objectsOuter, housesOuter, (!compatibilityReversed ? ext.objects : natal.objects), (!compatibilityReversed ? ext.houses : natal.houses), (!compatibilityReversed ? natal.objects : ext.objects), (!compatibilityReversed ? natal.houses : ext.houses), synastryAspects, compatibilityTransitMode));
                }
                else {
                    objectsOuter = [];
                    housesOuter = [];
                    transitPartnerAspects = [];
                    transitNatalAspects = [];
                }
            }
            if (compatibilityReversed) {
                return {
                    ...ext,
                    objects: [...ext.objects, ErisObjectPartner],
                    aspects: [...synastryAspects, ...transitPartnerAspects, ...transitNatalAspects],
                    objectsExt: [...natal.objects, ErisObjectNatal],
                    housesExt: natal.houses,
                    objectsOuter,
                    housesOuter,
                    transitPartnerAspects,
                    transitNatalAspects,
                    name: 'natal'
                };
            }
            else {
                return {
                    ...natal,
                    objects: [...natal.objects, ErisObjectNatal],
                    aspects: [...synastryAspects, ...transitPartnerAspects, ...transitNatalAspects],
                    objectsExt: [...ext.objects, ErisObjectPartner],
                    housesExt: ext.houses,
                    objectsOuter,
                    housesOuter,
                    transitPartnerAspects,
                    transitNatalAspects,
                    name: partner.name
                };
            }
        }
        else {
            const partnerNat = await astro.natal(localTime(partner), partner.place.lat, partner.place.lon, false);
            if (partnerExt && partnerNatal) {
                return {
                    ...natal,
                    objects: [...natal.objects, ErisObjectNatal],
                    aspects: astro.synastryAspects(natal.objects, partnerNat.objects),
                    objectsExt: [...partnerNat.objects, ErisObjectPartner],
                    housesExt: partnerNat.houses,
                    objectsOuter: [],
                    housesOuter: [],
                    name: partner.name
                };
            }
            else if (partnerExt && !partnerNatal) {
                return {
                    ...partnerNat,
                    objects: [...partnerNat.objects, ErisObjectPartner],
                    aspects: astro.natalAspects(partnerNat.objects, undefined, partnerNat.houses),
                    objectsExt: [],
                    housesExt: [],
                    objectsOuter: [],
                    housesOuter: [],
                    name: partner.name
                };
            }
            else {
                return {
                    ...natal,
                    objects: [...natal.objects, ErisObjectNatal],
                    aspects: astro.natalAspects(natal.objects),
                    objectsExt: [],
                    housesExt: [],
                    objectsOuter: [],
                    housesOuter: [],
                    name: partner.name
                };
            }
        }
    }
    if (isRelocation(mode)) {
        const d = (_g = (_f = form.relocation) === null || _f === void 0 ? void 0 : _f[mode]) !== null && _g !== void 0 ? _g : form.natal;
        const relocation = await astro.natal(localTime(d), d.place.lat, d.place.lon);
        const natal = await astro.natal(localTime(form.natal), form.natal.place.lat, form.natal.place.lon);
        let aspects = astro.natalAspects(relocation.objects, undefined, undefined, undefined, { floatingOrbise: 0 });
        aspects = calcNatalAspectsWithFloatingOrbiseCorrector(aspects, natal, floatingOrbise);
        const ErisObjectRelocation = await astro.object(localTime(d), 136199 + 10000);
        return {
            ...natal,
            objects: [...natal.objects, ErisObjectNatal],
            aspects: [
                ...aspects,
                ...houseAspects(relocation.objects, relocation.houses, aspects.length, (astroProfile === null || astroProfile === void 0 ? void 0 : astroProfile.id) === 1 ? 5 : 4).map((a) => {
                    const z = a.obj1;
                    a.obj1 = a.obj2;
                    a.obj2 = z;
                    return a;
                }),
            ],
            objectsExt: [...relocation.objects, ErisObjectRelocation],
            housesExt: relocation.houses,
            objectsOuter: [],
            housesOuter: []
        };
    }
    if (!form.prognostics)
        throw new Error('Empty prognostics data');
    let { dt: progDt, gmt, place: { lat, lon } } = form.prognostics;
    progDt = getLocalTime(progDt, gmt, lat, lon);
    const ext = await (async () => {
        switch (mode) {
            case 'transits': return await astro.natal(progDt, lat, lon, false);
            case 'directions': return getDirections(natal, localTime(form.natal), progDt);
            case 'solars': return await astro.solars(natal.objects[ObjectType.Sun].lon, progDt, lat, lon);
            case 'prog_prog':
            case 'prog_natal': return await astro.progressions(localTime(form.natal), progDt, lat, lon);
            default: return { houses: [], objects: [] };
        }
    })();
    let forErisDateTime = mode === 'transits'
        ? progDt
        : mode === 'directions'
            ? localTime(form.natal)
            : ext.dt;
    let ErisObjectPrognostics = await astro.object(forErisDateTime, 136199 + 10000);
    if (mode === 'directions') {
        ErisObjectPrognostics = directionShift(ErisObjectPrognostics, ext.shift);
    }
    const [prognosticsExt, prognosticsNatal] = [
        ((_h = (mapIndicator || {}).prognosticsExt) === null || _h === void 0 ? void 0 : _h[mode]) || true,
        ((_j = (mapIndicator || {}).prognosticsNatal) === null || _j === void 0 ? void 0 : _j[mode]) || true
    ];
    const res = (prognosticsExt && prognosticsNatal)
        ? {
            ...natal,
            objects: [...natal.objects, ErisObjectNatal],
            aspects: astro.prognosticsAspects(mode, natal.objects, natal.houses, ext.objects, ext.houses, false),
            objectsExt: [...ext.objects, ErisObjectPrognostics],
            housesExt: ext.houses,
            objectsOuter: [],
            housesOuter: []
        }
        : (prognosticsExt && !prognosticsNatal)
            ? {
                ...ext,
                objects: [...ext.objects, ErisObjectPrognostics],
                aspects: astro.prognosticsAspects(mode, natal.objects, natal.houses, ext.objects, ext.houses, Boolean('forDoubleMapWithOutNatal')),
                objectsExt: [],
                housesExt: [],
                objectsOuter: [],
                housesOuter: []
            }
            : {
                ...natal,
                objects: [...natal.objects, ErisObjectNatal],
                aspects: astro.natalAspects(natal.objects),
                objectsExt: [],
                housesExt: [],
                objectsOuter: [],
                housesOuter: []
            };
    return (res);
}
